<div class="max-w-3xl mx-auto p-6 h-full flex flex-col justify-between overflow-auto">
  <!-- Header -->
  <div>
    <div class="flex items-center space-x-2 mb-8">
      <span class="text-2xl">🛍️</span>
      <h1 class="text-3xl font-semibold">Cart</h1>
    </div>

    @for (item of cartService.displayCart().rows; track item.artwork + 'cart_artwork') {
      <wun-artwork-card [artwork]="item" />
    }

  </div>
  <div class="py-4">
    <!-- Totale -->
    <div class="text-right text-xl font-bold flex justify-between">
      @if (cartService.shippingCosts()) {
        <div class="font-normal">Shipping costs:</div> {{cartService.shippingCosts() | currency : 'EUR' : '   €' : '1.2-2' }}
      } @else {
        <div class="font-normal">Shipping costs:</div> N/A
      }
    </div>
    <div class="text-right text-xl font-bold mb-6 flex justify-between">
      <div class="font-normal">
        Total:
      </div>
      {{(cartService.totalCart() + cartService.shippingCosts()) | currency : 'EUR' : '   €' : '1.2-2' }}
    </div>

    <!-- Buttons -->
    <div class="flex space-x-4">
      @if (addressService.address()) {
        <button wunButton primary (click)="calculateShipping()">
          Calculate shipping cost
        </button>
      }

      @if (showCheckoutButton()) {
        <button routerLink="/checkout" [disabled]="cartService.totalCart() === 0" (click)="hideDrawer()" wunButton light>
          Checkout
        </button>
      }

    </div>
  </div>

</div>
